import axios from 'axios';
import React, { useEffect, useState } from 'react'
import cookie from "js-cookie"
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
export default function Shop() {
    const navigate = useNavigate();
    const [data, setdata] = useState([])
    const getCookieUser = cookie.get("user");
    const userInfo = getCookieUser ? JSON.parse(getCookieUser) : null;

    const getItemsdata = async () => {
        try {
            
            const result = await axios.get(
              `${process.env.REACT_APP_API_URL}/getAllCar`
            );
            console.log(result, "result")
            setdata(result.data.body)
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
      
        getItemsdata()
    }, [])

    const bookSinglePage=(id)=>{

        if (!userInfo) {
            toast.error("Please login first");
            return;
        }
        navigate(`/checkout/${id}`)
    }
    return (
        <>
            <div className='container mt-5 py-5'>
                <h1 className='border text-center py-2'>Book Car Washing Service</h1>
                <div className='row'>
                    {data?.map((e) => (
                        <div className='col-lg-6 border px-3 py-3'>
                            <div className='row'>
                                <div className='col-lg-6 px-3 py-3'>
                                    <img src={e?.image} alt="" srcset="" className='w-100 px-2 py-2' />
                                </div>
                                <div className='col-lg-6'>
                                    <h4>{e?.title}</h4>
                                    <p>Washing Price: Rs. {e?.price}</p>
                                    <p>{e?.description}</p>
                                    <div className="d-flex gap-2">
                                        <button onClick={(()=>navigate(`/book/${e?._id}`))} class="btn btn-primary py-3 px-4 animated slideInDown">
                                            <i class="fa fa-calendar me-2"></i>Book Service
                                        </button>
                                        <button onClick={(()=>bookSinglePage(e?._id))} class="btn btn-outline-primary py-3 px-4 animated slideInDown">
                                            <i class="fa fa-info-circle me-2"></i>Book Wash Service
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}


                </div>
            </div>
        </>
    )
}
